import React, { useState, useEffect } from 'react';
import { Form, Button, Alert, Modal } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../services/api';
import './ResetPassword.css';

const ResetPassword: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  useEffect(() => {
    const tokenParam = searchParams.get('token');
    const emailParam = searchParams.get('email');
    
    if (tokenParam) setToken(tokenParam);
    if (emailParam) setEmail(decodeURIComponent(emailParam));
  }, [searchParams]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!token || !email) {
      setError('Link di reset non valido o incompleto.');
      return;
    }

    if (password !== passwordConfirmation) {
      setError('Le password non corrispondono');
      return;
    }

    if (password.length < 8) {
      setError('La password deve essere di almeno 8 caratteri');
      return;
    }

    setLoading(true);

    try {
      await authService.resetPassword({
        token,
        email,
        password,
        password_confirmation: passwordConfirmation,
      });
      setSuccess('Password reimpostata con successo.');
      setShowSuccessModal(true);
      setTimeout(() => {
        navigate('/login');
      }, 2500);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Errore durante il reset della password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-page">
      <div className="reset-wrapper">
        <div className="reset-card">
          <div className="reset-header">
            <h1>Reimposta Password</h1>
            <p>Inserisci la nuova password per il tuo account</p>
          </div>

          {error && <Alert variant="danger" className="reset-alert">{error}</Alert>}
          {success && <Alert variant="success" className="reset-alert">{success}</Alert>}

          <Form onSubmit={handleSubmit} className="reset-form">
            <div className="reset-field">
              <Form.Label>Nuova Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Inserisci la nuova password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={8}
                className="reset-input"
              />
              <div className="reset-help">Minimo 8 caratteri</div>
            </div>

            <div className="reset-field">
              <Form.Label>Conferma Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Conferma la nuova password"
                value={passwordConfirmation}
                onChange={(e) => setPasswordConfirmation(e.target.value)}
                required
                minLength={8}
                className="reset-input"
              />
            </div>

            <Button type="submit" className="reset-submit" disabled={loading}>
              {loading ? 'Reimpostazione in corso...' : 'Reimposta Password'}
            </Button>
          </Form>
        </div>

        <p className="reset-footer">© 2021 All rights reserved Estetica Cruciani</p>
      </div>

      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
        className="reset-success-modal"
      >
        <div className="reset-success-box">
          <button
            type="button"
            className="reset-success-close"
            onClick={() => setShowSuccessModal(false)}
            aria-label="Chiudi"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M2 2l12 12M14 2L2 14" />
            </svg>
          </button>
          <div className="reset-success-content">
            <h2 className="reset-success-title">Password Reimpostata!</h2>
            <p className="reset-success-text">La tua password è stata reimpostata con successo.</p>
          </div>
          <Button
            type="button"
            className="reset-success-btn"
            onClick={() => navigate('/login')}
          >
            Torna al login
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default ResetPassword;
